// extracted by mini-css-extract-plugin
module.exports = {"container":"GSTInfoComponent_container__IWi3s","iconStyle":"GSTInfoComponent_iconStyle__161N8","textStyle":"GSTInfoComponent_textStyle__3g5Ss"};